import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import LoginPage from "../components/pages/login/LoginPage";
import {
  IloginRequestPayload,
  IMFASessionPayload,
  IMFAFallbackPayload,
  IMFASessionValidatePayload, IKeycloakAuthExchangeRequestPayload,
} from "../interfaces/Index";
export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.userAuth.isLoading,
    isError: state.userAuth.isError,
    error: state.userAuth.error,
    userAuth: state.userAuth.auth,
    mfa: state.userAuth.mfa,
    isValidateMFASuccess: state.userAuth.isValidateMFASuccess,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    asyncLogin: (payload: IloginRequestPayload) =>
      dispatch(actions.login(payload)),
    getMfaSession: (payload: IMFASessionPayload) =>
      dispatch(actions.getMfaSession(payload)),
    validateMfaSession: (payload: IMFASessionValidatePayload) =>
      dispatch(actions.validateMfaSession(payload)),
    validateKeycloakSessionAction: (payload: IKeycloakAuthExchangeRequestPayload) =>
        dispatch(actions.validateKeycloakSessionAction(payload)),
    mfaFallbackSession: (payload: IMFAFallbackPayload) =>
      dispatch(actions.mfaFallbackSession(payload)),
  };
};

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(LoginPage);
export default LoginContainer;
